export enum OrderStopType {
  STORE = 1,
  CLIENT = 2,
  ADDITIONAL = 3,
  TRANSFER = 4,
  MESSENGER = 5,
  TRUCK = 6,
}
